import { createIconComponent } from '../../factory/create-icon-component';

export const AutoneIcon = createIconComponent(
  'AutoneIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.31615 0.903243C5.74022 0.334825 6.40752 0 7.11643 0H7.94788H15.7524C16.9931 0 17.9989 1.00651 17.9989 2.24804V10.7113C14.6071 11.0164 11.9489 13.8687 11.9489 17.3421C11.9489 20.8156 14.6071 23.6679 17.9989 23.973V24H2.24658C1.00582 24 0 22.9935 0 21.752V8.77585C0 8.29113 0.156548 7.81943 0.446306 7.43105L5.31615 0.903243ZM18.799 22.5466C21.6714 22.5466 24 20.2165 24 17.3421C24 14.4679 21.6714 12.1378 18.799 12.1378C15.9265 12.1378 13.598 14.4679 13.598 17.3421C13.598 20.2165 15.9265 22.5466 18.799 22.5466Z"
      fill="currentColor"
    />
  </svg>,
);
